import { makeStyles } from "@material-ui/core";
export const useStyles = makeStyles((theme) => ({
  defaultContainer: {
    position: "relative",
    maxWidth: 900,
    background: '#FFF',
    borderRadius: 8,
    overflowY: "auto",
    overflowX: "hidden",
  },
  listContainer: {
    "& .card": {
      margin: theme.spacing(1),
    }
  },
  list: {
    padding: 16,
    overflowX: "hidden",
    overflow: "auto",
    position: "relative",
    display: 'flex',
    width: '100%',
    justifyContent: 'center'
  },
  contentForms: {
    flex: "1 1 auto",
    padding: theme.spacing(2),
    overflowX: "hidden",
    overflowY: "auto",
    "& * > form": {
      visibility: "visible",
    },
    "&  .tabs-class": {
      visibility: "visible",
    },
  },
  contentFormsLoading: {
    "& * > form": {
      visibility: "hidden",
    },

    "&  .tabs-class": {
      visibility: "hidden",
    },
  },
  acoes: {
    flex: "0 0 auto",
    padding: theme.spacing(2),
  },
  switchInput: {
    "&.MuiFormControlLabel-labelPlacementStart": {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: 0,
      fontWeight: '600!important'
    },
  },
  switchInputContainer: {
    backgroundColor: '#F4F4F4',
    padding: '8px 16px',
    borderRadius: theme.shape.borderRadius,
    marginBottom: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
  },
  bloqueioLabel: {
    fontWeight: 600,
    fontSize: 14,
  },
  bloqueioToggleGroup: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 2,
    border: '1px solid #E0E0E0',
    '& .MuiToggleButton-root': {
      border: 'none',
      borderRadius: '18px !important',
      textTransform: 'none',
      fontWeight: 600,
      fontSize: 12,
      padding: '4px 12px',
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.04)',
      },
    },
    '& .MuiToggleButton-root.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  bloqueioToggleButton: {
    minWidth: 72,
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1rem',
    borderRadius: theme.shape.borderRadius,
    marginBottom: 10,
    gap: 8,
    backgroundColor: '#F4F4F4',
    '& .MuiFormControl-root': {
      backgroundColor: '#fff'
    }
  }
}));
